document.addEventListener('DOMContentLoaded', (event) => {
    let mySwiper = new Swiper('.youtube-playlist__boxes', {
        // Parametry Swiper'a
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
        },
    });

    console.log('mySwiper', mySwiper);

    if (window.innerWidth < 1200) {
        mySwiper.init();
    }
})